import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {Linear} from "gsap";

export class DFGameConfig {
    public static totalReels: number = 6;
    public static totalSymsPerReel: number = 5;
    public static defaultGameAreaSize: number[] = [5, 5, 5, 5, 5, 5];
    public static stepDuration: number = 0.05;
    public static reelAllInStopDelayFastSpin: number = DFGameConfig.stepDuration * 0.5;
    public static reelAllInStopDelay: number = DFGameConfig.stepDuration;
    public static reelAllOutStopDelayFastSpin: number = DFGameConfig.stepDuration * 0.5;
    public static reelAllOutStopDelay: number = DFGameConfig.stepDuration;
    public static symbolWidth: number = 118;
    public static symbolHeight: number = 118;
    public static MAIN_REELS_VIEW_MASK_POSITION: PIXI.Point = new PIXI.Point(0, 0);
    public static capWinAnticipationWiggleX = CustomWiggle.create("Wiggle.easeOut", {wiggles: 70, type: "easeOut"});
    public static capWinAnticipationWiggleY = CustomWiggle.create("Wiggle.easeOut", {wiggles: 70, type: "easeOut"});
    public static bigWinAnticipationWiggle = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles: 50,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });
    public static bigWinAnticipationWiggle2 = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles: 40,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone,
    });

    public static reelPositions: PIXI.Point[] = [
        new PIXI.Point(0, 0),
        new PIXI.Point(DFGameConfig.symbolWidth, 0),
        new PIXI.Point(DFGameConfig.symbolWidth * 2, 0),
        new PIXI.Point(DFGameConfig.symbolWidth * 3, 0),
        new PIXI.Point(DFGameConfig.symbolWidth * 4, 0),
        new PIXI.Point(DFGameConfig.symbolWidth * 5, 0),
    ];
    public static reelSpinStartSymbolDelay: number = 0.03;
    //All in total spin time
    public static mainAllInTotalSpinDuration: number = 0.3;
    public static mainAllInTotalSpinDurationFastSpin: number = 0.2;
    //Spin-in gap between symbols
    public static mainReelSpinStopSymbolDelayFastSpin: number = 0.02;
    public static mainReelSpinStopSymbolDelay: number = 0.04;
    //Blur delay, all in
    public static mainReelAllInBlurDelayFastSpin: number = 0.010;
    public static mainReelAllInBlurDelay: number = 0.22;
}